module.exports = __webpack_public_path__ + "img/mockup_benefit_260303.71999dac.png";